"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _SearchService = _interopRequireDefault(require("@insided/destination/modules/Search/services/SearchService"));

var _connectors = require("@insided/shared/services/algolia/connectors");

var _searchResult = require("../search-result");

var _utils = require("@insided/destination/modules/Search/utils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var AllResults = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(AllResults, _Component);

  var _super = _createSuper(AllResults);

  function AllResults() {
    var _this;

    (0, _classCallCheck2.default)(this, AllResults);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      topicInfoMap: {},
      accumulatedSearchResultHits: []
    });
    return _this;
  }

  (0, _createClass2.default)(AllResults, [{
    key: "componentDidUpdate",
    value: function () {
      var _componentDidUpdate = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(prevProps) {
        var _this$props$searchRes, _prevProps$searchResu;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (JSON.stringify((_this$props$searchRes = this.props.searchResults) === null || _this$props$searchRes === void 0 ? void 0 : _this$props$searchRes.hits) !== JSON.stringify((_prevProps$searchResu = prevProps.searchResults) === null || _prevProps$searchResu === void 0 ? void 0 : _prevProps$searchResu.hits)) {
                  this.fetchTopics();
                  this.updateAccumulatedSearchResultHits();
                }

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidUpdate(_x) {
        return _componentDidUpdate.apply(this, arguments);
      }

      return componentDidUpdate;
    }()
  }, {
    key: "updateAccumulatedSearchResultHits",
    value: function updateAccumulatedSearchResultHits() {
      var _this$props$searchRes2;

      var joinWith = [];

      if (this.props.pageCount > 0) {
        joinWith = this.state.accumulatedSearchResultHits;
      }

      this.setState({
        accumulatedSearchResultHits: joinWith.concat(((_this$props$searchRes2 = this.props.searchResults) === null || _this$props$searchRes2 === void 0 ? void 0 : _this$props$searchRes2.hits) || [])
      });
    }
  }, {
    key: "fetchTopics",
    value: function () {
      var _fetchTopics = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var _this$props$searchRes3, _this$props$searchRes4;

        var communityHits, topicInfoMap;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                communityHits = (_this$props$searchRes3 = this.props.searchResults) === null || _this$props$searchRes3 === void 0 ? void 0 : (_this$props$searchRes4 = _this$props$searchRes3.hits) === null || _this$props$searchRes4 === void 0 ? void 0 : _this$props$searchRes4.filter(function (hit) {
                  return hit.gs_data_source === 'community' && !(0, _utils.isCommunityResultEvent)(hit);
                });

                if (communityHits !== null && communityHits !== void 0 && communityHits.length) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return");

              case 3:
                _context2.next = 5;
                return fetchAndGetTopicInfoMap(communityHits);

              case 5:
                topicInfoMap = _context2.sent;

                if (topicInfoMap) {
                  this.setState(function (prevState) {
                    return {
                      topicInfoMap: _objectSpread(_objectSpread({}, prevState.topicInfoMap), topicInfoMap)
                    };
                  });
                }

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function fetchTopics() {
        return _fetchTopics.apply(this, arguments);
      }

      return fetchTopics;
    }()
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.fetchTopics();
    }
  }, {
    key: "render",
    value: function render() {
      var _searchResults$hits;

      var _this$state = this.state,
          topicInfoMap = _this$state.topicInfoMap,
          accumulatedSearchResultHits = _this$state.accumulatedSearchResultHits;
      var _this$props = this.props,
          _clickCallback = _this$props.clickCallback,
          timeConfig = _this$props.timeConfig,
          searchResults = _this$props.searchResults;
      return (0, _preact.h)("div", {
        className: "all-results"
      }, (accumulatedSearchResultHits.length ? accumulatedSearchResultHits : (_searchResults$hits = searchResults === null || searchResults === void 0 ? void 0 : searchResults.hits) !== null && _searchResults$hits !== void 0 ? _searchResults$hits : []).map(function (hit, index) {
        if ((0, _utils.isUnifiedCommunityHit)(hit)) {
          if ((0, _utils.isCommunityResultEvent)(hit)) {
            return (0, _preact.h)(_searchResult.EventSearchResult, {
              key: hit.id,
              hit: hit,
              timeConfig: timeConfig
            });
          } else {
            var topicHit = topicInfoMap[hit.id];
            if (!topicHit) return null;
            return (0, _preact.h)(_searchResult.CommunitySearchResult, {
              key: topicHit.id,
              topic: topicHit,
              clickCallback: function clickCallback() {
                return _clickCallback(hit, 'community', index);
              }
            });
          }
        } else {
          return (0, _preact.h)(_searchResult.ExternalSearchResult, {
            key: hit.objectID,
            hit: hit,
            clickCallback: function clickCallback() {
              var _hit$gs_data_source;

              return _clickCallback(hit, (_hit$gs_data_source = hit.gs_data_source) !== null && _hit$gs_data_source !== void 0 ? _hit$gs_data_source : hit.source, index);
            }
          });
        }
      }));
    }
  }]);
  return AllResults;
}(_preact.Component);

function fetchAndGetTopicInfoMap(_x2) {
  return _fetchAndGetTopicInfoMap.apply(this, arguments);
}

function _fetchAndGetTopicInfoMap() {
  _fetchAndGetTopicInfoMap = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(communityHits) {
    var topicInfo;
    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return _SearchService.default.fetchMetadataForTopics(communityHits, function () {}, 'allResults');

          case 2:
            topicInfo = _context3.sent;

            if (topicInfo !== null && topicInfo !== void 0 && topicInfo.length) {
              _context3.next = 5;
              break;
            }

            return _context3.abrupt("return", null);

          case 5:
            return _context3.abrupt("return", topicInfo.reduce(function (acc, topic) {
              acc[topic.id] = topic;
              return acc;
            }, {}));

          case 6:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _fetchAndGetTopicInfoMap.apply(this, arguments);
}

var _default = (0, _connectors.connectStateResults)(AllResults);

exports.default = _default;